import {$messageLoad, $messageContainer} from '../../common/message/message';
import {cr} from 'fire-wind-water';
import {preview} from './preview';
import {renderComponents} from '../../components';
import {getCustomForm} from '../../modules/customform';
import {initPiwik} from '../piwik';
import {userLoad} from '../user';
import {isLink, actionBrowse} from '../browse';

async function $stemplateLoad(fn) {
  initPiwik(); // 设置piwik
  $messageLoad(1); // 通知cms已经加载完毕
  $messageContainer([{name: 'sk-cms-main'}]);  // 通知cms当前默认主容器
  isLink();  // 如果是正式链接，判断跳转
  preview(); // 判断当前是否是预览，设置页面，根据条件获取模板数据
  renderComponents(); // 如果是正式链接，初始化组件内的各种方法
  await userLoad();  // 获取用户信息
  actionBrowse();  // 记录浏览行为
  getCustomForm(); // 获取表单
  // 执行回调，这里已有用户数据，其他获取如表单信息没有
  if (cr.isFunction(fn)) {
    fn();
  }
}

export {
  $stemplateLoad
};
